/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FontIcon } from 'react-toolbox';
import Paginate from 'components/Pagination';
import AssessmentSuggestionsButtons from 'assessmentSuggestionsButtons';
import Card from 'components/Card';
import { ResourceCardElement } from 'components/ResourceCardElements';
import { getDisplayTime } from '../../../../../utils/dateUtils';
import S from './suggestions.scss';
import cardStyles from 'styles/resourceCard.scss';

class AssessmentSuggestionsList extends Component {
  constructor(props) {
    super(props);
    const { suggestions, totalCount, suggestionKey = null } = this.props;
    const propSuggestions = suggestions || [[]];
    const currentPage = suggestionKey ? this.findPageFromKey(suggestionKey, propSuggestions) : 1;
    this.state = {
      suggestions: propSuggestions,
      totalCount,
      currentPage,
      apptsByPage: propSuggestions[currentPage - 1] || [],
    };
    this.getApptsByPage = this.getApptsByPage.bind(this);
  }

  getApptsByPage = page => this.setState({
    currentPage: page, apptsByPage: this.state.suggestions[page - 1],
  });

  resetState = (suggestions, totalCount) => this.setState({
    suggestions,
    totalCount,
    currentPage: 1,
    apptsByPage: suggestions[0] || [],
  });

  findPageFromKey = (key, propSuggestions) => {
    let currentPage = 1;
    if (propSuggestions[0].length < 1) return currentPage;
    propSuggestions.forEach((page, i) => {
      page.forEach((appt) => {
        if (appt.key === key) currentPage = i + 1;
      });
    });
    return currentPage;
  };

  formattedTimeWindow = (startTime, endTime) => (startTime && endTime ?
    `${getDisplayTime(startTime)} - ${getDisplayTime(endTime)} ${this.props.zone}` :
    'N/A');

  renderSuggestionList = () => {
    const { apptsByPage, currentPage, totalCount } = this.state;
    return (<div className={S.suggestionCard__container}>
      <section className={S.suggestionCard}>
        {this.renderButtons()}
        {totalCount > 0 ? (<Fragment>
          <div className={S.suggestionCard__title}>
            <span>Available Assessments</span>
          </div>
          <div className={S.suggestionCard__content}>
            {apptsByPage.map(appt => this.renderSuggestion(appt))}
          </div>
          <br />
          <div className={S.paginationContainer}>
            <Paginate
              denominator={5}
              currentPage={currentPage}
              totalCount={totalCount}
              getListPage={page => this.getApptsByPage(page)}
              buttonStyle="listPageButton"
            />
          </div>
        </Fragment>) : <div>
          No suggestions available.
          Please check estimator max appointment limits and existing schedule.
        </div>}
      </section>
    </div>);
  };

  renderSuggestion = (appt) => {
    const { suggestionKey, handleSelect } = this.props;
    const { key, name, arrival_start_time, arrival_end_time, start_date } = appt;
    const selected = suggestionKey === key;
    return (<Card
      key={key}
      id={`appointment${key}`}
      className={cardStyles.selectableCard}
      altColor={selected}
      onClick={selected ? () => {} : () => handleSelect(appt)}
    >
      <ResourceCardElement
        title="Name"
        value={name}
        size="medium"
        theme={S}
      />
      <ResourceCardElement
        title=" Date"
        value={start_date}
        size="medium"
        theme={S}
      />
      <ResourceCardElement
        title="Arrival Window"
        value={this.formattedTimeWindow(arrival_start_time, arrival_end_time)}
        size="medium"
        theme={S}
      />
      <div className={S.checkboxContainer}>
        <ResourceCardElement size="full">
          <FontIcon
            className={selected ? S.selectedCheckbox : S.emptyCheckbox}
            value={selected ? 'check_box' : 'check_box_outline_blank'}
          />
        </ResourceCardElement>
      </div>
    </Card>);
  }

  renderButtons = () => (<AssessmentSuggestionsButtons
    isCcs={this.props.isCcs}
    queryStart={this.props.queryStart}
    handleQueryStartChange={this.props.handleQueryStartChange}
    errors={this.props.errors}
    loadNewSuggestions={this.props.rerunLoadSuggestions}
    handleSuggestionSubmit={this.props.handleSubmit}
    handleShowAssessmentSuggestions={this.props.handleShowAssessmentSuggestions}
    suggestionKey={this.props.suggestionKey}
    isAfternoon={this.props.isAfternoon}
  />);

  renderNoAppointmentsMsg = () => (<Card className={S.msgCard}>
    <h5>No assessment suggestions.</h5>
    {this.renderButtons()}
  </Card>);

  render = () => (<section>
    {this.state.suggestions[0].length > 0 ?
      this.renderSuggestionList() : this.renderNoAppointmentsMsg()}
  </section>);
}

AssessmentSuggestionsList.defaultProps = { suggestionKey: null };

AssessmentSuggestionsList.propTypes = {
  isCcs: PropTypes.bool,
  zone: PropTypes.string,
  suggestions: PropTypes.array.isRequired,
  totalCount: PropTypes.number.isRequired,
  suggestionKey: PropTypes.string,
  queryStart: PropTypes.string.isRequired,
  handleSelect: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleQueryStartChange: PropTypes.func.isRequired,
  handleShowAssessmentSuggestions: PropTypes.func,
  rerunLoadSuggestions: PropTypes.func.isRequired,
  isAfternoon: PropTypes.bool,
  errors: PropTypes.object,
};

export default connect(() => ({}), {})(AssessmentSuggestionsList);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/schedule/components/assessmentSuggestionsList.jsx